import React from 'react';
import Helmet from 'react-helmet';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { mapEntityToKeyword } from 'utils/config';
import img0 from '../../assets/img/our-partners-img1.png';
import img1 from '../../assets/img/NVPC.png';
import img2 from '../../assets/img/NYC.png';
import img3 from '../../assets/img/Young Change Makers.png';
import img4 from '../../assets/img/Paym.png';
import img5 from '../../assets/img/AMK.png';
import img6 from '../../assets/img/Touch.png';
import img7 from '../../assets/img/Scape.png';
import img8 from '../../assets/img/Children.png';
import img9 from '../../assets/img/dbs.png';
import img10 from '../../assets/img/nus.png';
import img11 from '../../assets/img/popejaithai.png';
import styles from './OurPartners.module.scss';

export default function OurPartners() {
  return (
    <div className="main-section" style={{ margin: '2% 0'}}>
      <div className="page-section">
        <div className="container">
          <Helmet>
            <title>Our Partners</title>
          </Helmet>
          <div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="cs-section-title center">
                <h2>Our Partners</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-section">
        <div className="container">
          <div className="row">
            <div className="section-fullwidtht col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="row">
                <img src={img0} width="680" alt="Our Partners" />
              </div>
            </div>
            <div className="container center">
              <div className="col-lg-10 col-md-12 col-sm-12 col-xs-12">
                <div className="visible-md visible-lg" style={{ margin: '30px 0 40px' }}>
                  <div className="row" style={{ paddingTop: '40px' }}>
                    <div className="col-md-3">
                      <img src={img1} alt="Our Partners" />
                    </div>
                    <div className="col-md-3">
                      <img src={img2} alt="Our Partners" />
                    </div>
                    <div className="col-md-3">
                      <img src={img3} alt="Our Partners" />
                    </div>
                    <div className="col-md-3">
                      <img src={img4} alt="Our Partners" />
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: '40px' }}>
                    <div className="col-md-3">
                      <img src={img5} alt="Our Partners" />
                    </div>
                    <div className="col-md-6">
                      <img src={img6} alt="Our Partners" />
                    </div>
                    <div className="col-md-3">
                      <img src={img7} alt="Our Partners" />
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: '40px' }}>
                    <div className="col-md-3">
                      <img src={img8} alt="Our Partners" />
                    </div>
                    <div className="col-md-3">
                      <img src={img9} alt="Our Partners" />
                    </div>
                    <div className="col-md-3">
                      <img src={img10} alt="Our Partners" />
                    </div>
                    <div className="col-md-3">
                      <img src={img11} alt="Our Partners"/>
                    </div>
                  </div>
                </div>
								<div className="row center visible-sm visible-xs">
									<div className={styles.ourPartners}>
										<div className={styles.ourPartnersList} style={{ paddingBottom: '30px' }}>
											<Slider
												dots={false}
												speed={1000}
												infinite
												autoplay
												slidesToShow={1}
												slidesToScroll={1}
												arrows
												responsive={[
													{
														breakpoint: 479,
														settings: {
															slidesToShow: 1,
														},
													},
													{
														breakpoint: 767,
														settings: {
															slidesToShow: 2,
														},
													},
													{
														breakpoint: 100000,
														settings: {
															slidesToShow: 4,
															autoplay: false,
															draggable: false,
														},
													},
												]}
											>
											<div className={styles.ourPartnersLogo}>
													<img src={img1} alt="Scape" />
											</div>
											<div className={styles.ourPartnersLogo}>
													<img src={img2} alt="NUS Enterprise" />
											</div>
											<div className={styles.ourPartnersLogo}>
													<img src={img3} alt="DBS" />
											</div>
											<div className={styles.ourPartnersLogo}>
													<img src={img4} alt="DBS" />
											</div>
											</Slider>
										</div>
										<div className={styles.ourPartnersList} style={{ paddingBottom: '30px' }}>
											<Slider
												dots={false}
												speed={1000}
												infinite
												autoplay
												slidesToShow={1}
												slidesToScroll={1}
												arrows
												responsive={[
													{
														breakpoint: 479,
														settings: {
															slidesToShow: 1,
														},
													},
													{
														breakpoint: 767,
														settings: {
															slidesToShow: 2,
														},
													},
													{
														breakpoint: 100000,
														settings: {
															slidesToShow: 3,
															autoplay: false,
															draggable: false,
														},
													},
												]}
											>
											<div className={styles.ourPartnersLogo}>
													<img src={img5} alt="Scape" />
											</div>
											<div className={styles.ourPartnersLogo}>
													<img src={img6} alt="NUS Enterprise" />
											</div>
											<div className={styles.ourPartnersLogo}>
													<img src={img7} alt="DBS" />
											</div>
											</Slider>
										</div>
										<div className={styles.ourPartnersList} style={{ paddingBottom: '20px' }}>
											<Slider
												dots={false}
												speed={1000}
												infinite
												autoplay
												slidesToShow={1}
												slidesToScroll={1}
												arrows
												responsive={[
													{
														breakpoint: 479,
														settings: {
															slidesToShow: 1,
														},
													},
													{
														breakpoint: 767,
														settings: {
															slidesToShow: 2,
														},
													},
													{
														breakpoint: 100000,
														settings: {
															slidesToShow: 4,
															autoplay: false,
															draggable: false,
														},
													},
												]}
											>
											<div className={styles.ourPartnersLogo}>
													<img src={img8} alt="Scape" />
											</div>
											<div className={styles.ourPartnersLogo}>
													<img src={img9} alt="NUS Enterprise" />
											</div>
											<div className={styles.ourPartnersLogo}>
													<img src={img10} alt="DBS" />
											</div>
											<div className={styles.ourPartnersLogo}>
													<img src={img11} alt="DBS" />
											</div>
											</Slider>
										</div>
									</div>
								</div>
								<div>
									<h2>
										HELP US TO CULTIVATE A SHARING COMMUNITY
									</h2>
								</div>
								<div>
								<div className="cs-section-title center">
									<strong>
										<Link
											to={`/${mapEntityToKeyword('donate')}/`}
											className={styles.button}
										>
											Donate
										</Link>
									</strong>
									<strong>
										<Link
											to={`/${mapEntityToKeyword('get-involved')}/`}
											className={styles.button}
										>
											Volunteer
										</Link>
									</strong>
								</div>
								</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}